import { gql } from "@apollo/client";

export const getAdAccounts = gql`
    query getAdAccounts($organizationId: ID!, $limit: Int!) {
        getMyLensesAdAccounts(input: { organizationId: $organizationId, limit: $limit }) {
            adAccounts {
                id
            }
        }
    }
`;
